export function getAppUrl (path) {
    if (typeof window !== 'undefined') {
        const hostname = window.location.hostname;
        if (hostname === 'storage.googleapis.com' || hostname.endsWith('.storage.googleapis.com')) {
            const pathSegments = window.location.pathname.split('/').filter(Boolean);
            const bucketName = pathSegments[0] || 'blockjo-app-live';

            let target = path.replace(/^\//, '');
            if (!target || target === '') {
                target = 'index.html';
            } else if (target.includes('?') || target.includes('#')) {
                const [base, rest] = target.split(/([?#].*)/, 2);
                const file = base.endsWith('.html') ? base : `${base || 'index'}.html`;
                target = `${file}${rest || ''}`;
            } else if (!target.endsWith('.html')) {
                target = `${target}.html`;
            }
            return `/${bucketName}/${target}`;
        }
    }

    if (!path.startsWith('/')) path = `/${path}`;
    if (path === '/') return '/';

    if (path.includes('?') || path.includes('#')) {
        const [base, rest] = path.split(/([?#].*)/, 2);
        const file = base.endsWith('.html') ? base : `${base}.html`;
        return `${file}${rest || ''}`;
    }
    if (!path.endsWith('.html')) {
        return `${path}.html`;
    }
    return path;
}

export function navigateTo (path) {
    if (typeof window !== 'undefined') {
        window.location.href = getAppUrl(path);
    }
}
